<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="customer.no" clearable placeholder="business.label.customerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="customer.name" clearable placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.company" clearable placeholder="business.label.company" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.contactor" clearable placeholder="business.label.contactMan" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.phone" clearable placeholder="business.label.phone" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="contactInfo.email" clearable placeholder="business.label.email" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="contactInfo.idType" :options="idTypes" clearable placeholder="business.label.idType" @change="refresh"/>
        <vxe-input v-model="contactInfo.idNumber" clearable placeholder="business.label.idNumber" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.country" clearable placeholder="business.label.country" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.province" clearable placeholder="business.label.province" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.city" clearable placeholder="business.label.city" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.district" clearable placeholder="business.label.district" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.town" clearable placeholder="business.label.town" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.village" clearable placeholder="business.label.village" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.street" clearable placeholder="business.label.street" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.postalCode" clearable placeholder="business.label.postalCode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="addressInfo.detailAddress" clearable placeholder="business.label.detailAddress" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable:true}"
        :data="list"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow:true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="direction.name" title="business.label.direction" width="80"/>
        <vxe-column field="contactInfo.company" title="business.label.company" width="80"/>
        <vxe-column field="contactInfo.contactor" title="business.label.contactor" width="80"/>
        <vxe-column field="contactInfo.phone" title="business.label.phone" width="80"/>
        <vxe-column field="contactInfo.email" title="business.label.email" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:idTypes}" field="contactInfo.idType" title="business.label.idType" width="80"/>
        <vxe-column field="contactInfo.idNumber" title="business.label.idNumber" width="80"/>
        <vxe-column field="addressInfo.country" title="business.label.country" width="80"/>
        <vxe-column field="addressInfo.province" title="business.label.province" width="80"/>
        <vxe-column field="addressInfo.city" title="business.label.city" width="80"/>
        <vxe-column field="addressInfo.district" title="business.label.district" width="80"/>
        <vxe-column field="addressInfo.town" title="business.label.town" width="80"/>
        <vxe-column field="addressInfo.village" title="business.label.village" width="80"/>
        <vxe-column field="addressInfo.street" title="business.label.street" width="80"/>
        <vxe-column field="addressInfo.postalCode" title="business.label.postalCode" width="80"/>
        <vxe-column field="addressInfo.detailAddress" title="business.label.detailAddress"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{readonly:true}}" field="addressInfo.defaults" title="business.label.defaults" width="60"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <AddressEditor ref="editor" :directions="directions" :id-types="idTypes" @success="refresh"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll, findOne } from '@/api/Api'
import { Address } from '@/api/dto/common/Address'
import { Customer } from '@/api/dto/common/Customer'
import { ContactInfo } from '@/api/dto/valueobject/ContactInfo'
import { AddressInfo } from '@/api/dto/valueobject/AddressInfo'
import AddressEditor from '@/views/basedata/address/AddressEditor.vue'

export default {
  name: 'AddressManagement',
  components: { AddressEditor },
  data() {
    return {
      loading: false,
      list: [],
      directions: [],
      idTypes: [
        { label: '身份证', value: '1' },
        { label: '军官证', value: '2' },
        { label: '护照', value: '3' },
        { label: '其他', value: '4' }
      ],
      page: 1,
      size: 20,
      contentSize: 0,
      customer: new Customer(),
      contactInfo: new ContactInfo(),
      addressInfo: new AddressInfo(),
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.76)
    }
  },
  created() {
    findOne('fieldFactory', { no: 'DIRECTION' }).then(res => {
      if (res.success) {
        this.directions = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('addressFactory', { 'customer.no': this.customer.no, 'customer.name': this.customer.name, contactInfo: this.contactInfo, addressInfo: this.addressInfo }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.list = res.result.map(item => {
            return new Address(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.customer = new Customer()
      this.contactInfo = new ContactInfo()
      this.addressInfo = new AddressInfo()
    },
    add() {
      this.$refs.editor.add()
    },
    edit(row) {
      this.$refs.editor.edit(row.id, false)
    },
    copy(row) {
      this.$refs.editor.edit(row.id, true)
    }
  }
}
</script>